var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.377 5.507A5.967 5.967 0 0 1 18.16 6.8a6 6 0 0 1 2.126 3.395c.09.552.14 1.11.15 1.67 0 4.717-.858 5.877-2.342 7.486l-.2.18v-.31a2.713 2.713 0 0 0-.705-1.845 2.698 2.698 0 0 0-1.766-.874H8.975c-1.305 0-3.587 0-4.673-1.45a8.197 8.197 0 0 1 0-7.096 5.417 5.417 0 0 1 4.893-2.449h5.182Zm0-1.5H9.195a6.958 6.958 0 0 0-3.489.754 6.983 6.983 0 0 0-2.66 2.385 9.62 9.62 0 0 0 0 8.727c1.415 1.999 4.086 2.129 5.98 2.129h6.447c.518 0 .996.66.996 1.22v2.298a.481.481 0 0 0 .469.48c.08 0 .159-.02.229-.06a10.428 10.428 0 0 0 2.073-1.54c1.843-1.998 2.76-3.538 2.76-8.536-.017-.67-.08-1.338-.19-1.999a7.399 7.399 0 0 0-1.215-2.719 7.6 7.6 0 0 0-2.73-2.326 7.574 7.574 0 0 0-3.488-.812Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.94c5f1de63226fb43a5905ea9032403c.svg";
export { ForwardRef as ReactComponent };